import { ApiResponse } from 'apisauce';

import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import {
  LandlordDetailedReportModel,
  LandlordDetailedReportResponseModel,
  LandlordDetailedReportSearchModel,
  LandlordReportFilterOptionsModel
} from '../shared/models/landlord-detailed-report.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'FINANCE_MODULE';

export function getLandlordDetailedReport(
  query: LandlordDetailedReportSearchModel
): Promise<LandlordDetailedReportModel | ErrorInfo> {
  return api
    .getLandlordDetailedReport(query)
    .then((response: ApiResponse<LandlordDetailedReportResponseModel, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return {
            rows: data.data,
            count: data.count || 0,
            totals: data.totals || {
              totalRentGeneratedPerUnit: 0,
              amountDueToLandlord: 0,
              expenses: 0,
              llAmount: 0
            },
            truncated: Boolean(data.truncated)
          };
        }

        return errorHelper(0, '', MODULE_NAME, (api.getLandlordDetailedReport as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getLandlordDetailedReport as any).displayName
      );
    });
}

export function getLandlordReportFilterOptions(): Promise<
  LandlordReportFilterOptionsModel | ErrorInfo
> {
  return api
    .getLandlordReportFilterOptions()
    .then((response: ApiResponse<ResponseModel<LandlordReportFilterOptionsModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        }

        return errorHelper(
          0,
          '',
          MODULE_NAME,
          (api.getLandlordReportFilterOptions as any).displayName
        );
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getLandlordReportFilterOptions as any).displayName
      );
    });
}
